'use client';

import dynamic from 'next/dynamic';

export const IframeWrapperNoSsr = dynamic(
  () => import('./IframeWrapper').then((m) => m.IframeWrapper),
  { ssr: false },
);
